import { render, staticRenderFns } from "./ArticleAuthorList.vue?vue&type=template&id=259fa127&scoped=true"
import script from "./ArticleAuthorList.vue?vue&type=script&lang=ts"
export * from "./ArticleAuthorList.vue?vue&type=script&lang=ts"
import style0 from "./ArticleAuthorList.vue?vue&type=style&index=0&id=259fa127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259fa127",
  null
  
)

export default component.exports